import { render, staticRenderFns } from "./events-dow-card.vue?vue&type=template&id=2c6e5993&scoped=true&"
import script from "./events-dow-card.vue?vue&type=script&lang=js&"
export * from "./events-dow-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e5993",
  null
  
)

export default component.exports